import * as angular from 'angular';
import GovernanceBridge from './bridges/GovernanceBridge';
angular
  .module('flowingly.runner.governance')
  .component('governance', GovernanceBridge);
